(() => {
  if (window.mccmReviewSwipeReady) return;
  window.mccmReviewSwipeReady = true;
  let gesture = null;
  let suppressClickUntil = 0;
  document.addEventListener('pointerdown', event => {
    const carousel = event.target.closest('.jdgm-testimonials-carousel');
    if (!carousel || !event.isPrimary || event.button !== 0 || event.target.closest('a, button')) return;
    gesture = { carousel, id: event.pointerId, x: event.clientX, y: event.clientY };
    carousel.setPointerCapture(event.pointerId);
  });
  document.addEventListener('pointercancel', () => { gesture = null; });
  document.addEventListener('pointerup', event => {
    if (!gesture || gesture.id !== event.pointerId) return;
    const { carousel, x, y } = gesture;
    gesture = null;
    const dx = event.clientX - x, dy = event.clientY - y;
    if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    const arrows = carousel.querySelectorAll('.jdgm-arrow');
    const arrow = arrows[dx < 0 ? 1 : 0];
    if (arrow) {
      suppressClickUntil = Date.now() + 500;
      arrow.click();
    }
  });
  document.addEventListener('click', event => {
    if (Date.now() < suppressClickUntil && event.target.closest('.jdgm-testimonials-carousel') && !event.target.closest('.jdgm-arrow')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
